import { Link } from "react-router-dom";
import { wymhJumpToSection } from "@/components/feature/wymh-site-header";

const WYMH_PLATFORMS = ["Android", "iOS", "HarmonyOS", "Windows"];

export default function WymhHero() {
  return (
    <section id="wymh-hero" className="wymh-anchor relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute top-0 left-0 w-full h-full">
        <img
          src="/images/wymh-hero-bg.jpg"
          alt="五一漫画漫画宇宙背景"
          title="五一漫画海量漫画阅读"
          className="w-full h-full object-top opacity-55"
        />
      </div>
      <div
        className="absolute top-0 left-0 w-full h-full"
        style={{
          backgroundImage:
            "linear-gradient(120deg, rgba(16,11,13,0.95) 0%, rgba(16,11,13,0.78) 48%, rgba(69,6,29,0.86) 100%)",
        }}
      ></div>
      <div className="absolute top-0 left-0 w-full h-full wymh-halftone-dark opacity-50"></div>

      <div className="relative w-full px-4 md:px-8 pt-[120px] md:pt-[170px] pb-16 md:pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-6 items-center">
          <div>
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/40 text-primary-200 text-xs md:text-sm font-label font-medium mb-6">
              <i className="ri-flashlight-fill text-accent-400 w-4 h-4 flex items-center justify-center"></i>
              优质漫画 · 四端同步 · 每日更新
            </span>

            <h1 className="wymh-heading text-background-50 text-6xl md:text-8xl leading-none mb-5">
              五一漫画
            </h1>

            <p className="text-background-100/90 text-base md:text-lg leading-8 max-w-xl mb-8">
              五一漫画汇聚都市、恋爱、玄幻、悬疑等六大品类，超过 12,000 部正版作品实时更新。一个账号多端同步追更，随时随地打开就是最新一话。
            </p>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 mb-8">
              <Link
                to="/download"
                className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-label text-base font-bold cursor-pointer whitespace-nowrap"
              >
                <i className="ri-download-2-line text-lg w-5 h-5 flex items-center justify-center"></i>
                立即下载
              </Link>
              <button
                type="button"
                onClick={() => wymhJumpToSection("wymh-preview")}
                className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-background-50/10 border border-background-50/25 text-background-50 font-label text-base font-bold cursor-pointer whitespace-nowrap hover:bg-background-50/15"
              >
                <i className="ri-smartphone-line text-lg w-5 h-5 flex items-center justify-center"></i>
                查看软件预览
              </button>
            </div>

            <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
              {WYMH_PLATFORMS.map((p) => (
                <span key={p} className="inline-flex items-center gap-2 text-background-100/80 text-sm">
                  <i className="ri-checkbox-circle-fill text-accent-400 w-4 h-4 flex items-center justify-center"></i>
                  {p} 版
                </span>
              ))}
            </div>
          </div>

          <div className="relative flex items-center justify-center">
            <div
              className="absolute w-[320px] h-[320px] md:w-[460px] md:h-[460px] rounded-full"
              style={{ backgroundImage: "radial-gradient(circle, rgba(216,30,96,0.55) 0%, rgba(216,30,96,0.18) 45%, rgba(216,30,96,0) 72%)" }}
            ></div>
            <span className="absolute -top-2 right-4 md:top-6 md:right-10 wymh-heading text-primary-500/30 text-[120px] md:text-[180px] leading-none select-none">
              51
            </span>
            <img
              src="/images/wymh-mascot.png"
              alt="五一漫画吉祥物小五"
              title="五一漫画吉祥物"
              className="relative w-[260px] md:w-[420px] h-auto object-top animate-wymh-float"
            />
          </div>
        </div>
      </div>
    </section>
  );
}